export { default } from './TitleHolderInfoPersonForm';
